import {
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Flex,
  Text
} from '@chakra-ui/react';
import React, { useState } from 'react';
import Icon from '../../atoms/Icon/Icon';
import { isMadPawsStore } from '../../../common/util';

const INCREMENT = 10;
const FacetItem = ({ facet, selectHandler, activeFilters, index, hideValue = false }) => {
  const [itemsToShow, setItemsToShow] = useState(INCREMENT);

  const loadMore = () => {
    setItemsToShow(prev => prev + INCREMENT);
  };

  return (
    <AccordionItem border={'none'} defaultChecked={true}>
      {({ isExpanded }) => (
        <>
          <AccordionButton
            p={index === 0 ? '0 0 8px' : '8px 0'}
            _hover={{
              background: 'none'
            }}
          >
            <Flex align={'center'} flex="1" textAlign="left" justify={'between'}>
              <Text fontWeight="bold" flex={1} color={'#202020'}>
                {facet.display}
              </Text>
              {isExpanded ? <Icon symbol={'facet-minus'} /> : <Icon symbol={'facet-plus'} />}
            </Flex>
          </AccordionButton>
          <AccordionPanel px={0} py={2} pb={10}>
            {facet.children.slice(0, itemsToShow).map((child, i) => (
              <Flex
                key={i}
                onClick={() =>
                  selectHandler({
                    type: facet.type,
                    name: facet.type === 'calculated_price' ? child.value : child.name
                  })
                }
                mb={4}
                gap={2}
                align={'center'}
                cursor={'pointer'}
                fontSize={14}
              >
                <Box flexShrink={0} alignSelf={'flex-start'}>
                  {!!activeFilters?.find(
                    filter =>
                      filter.type === facet.type &&
                      filter.filters.includes(
                        facet.type === 'calculated_price' ? child.value : child.name
                      )
                  ) ? (
                    <Icon symbol={'facet-selected'} />
                  ) : (
                    <Icon symbol={'facet-empty'} />
                  )}
                </Box>

                <Text alignSelf={'flex-start'} fontSize={14}>
                  {child.name} &nbsp;
                  {!hideValue && (
                    <Text color={'#7A8590'} as={'span'}>
                      {' '}
                      {child.value}
                    </Text>
                  )}
                </Text>
              </Flex>
            ))}
            {itemsToShow < facet.children.length && (
              <Button
                variant={'link'}
                fontSize={14}
                color={isMadPawsStore() ? 'var(--primary-default)' : 'var(--blue-06)'}
                fontWeight={500}
                onClick={loadMore}
              >
                + more
              </Button>
            )}
          </AccordionPanel>
        </>
      )}
    </AccordionItem>
  );
};

export default FacetItem;
